module.exports = __webpack_public_path__ + "img/ic_minprogram_instroduce_num.73785c72.png";